import { createFileRoute } from '@tanstack/react-router';
import { useMinWidth } from '@tupai/shell';
import ChildReportsPage from '@/components/child-reports-page';
import ChildHubPage from '@/components/child-hub-page';

// From `lg` the same URL renders the hub with the full reports list in place.
export const Route = createFileRoute('/_protected/children/$linkId/reports/')({
  component: ChildReportsRoute,
});

function ChildReportsRoute() {
  const isLg = useMinWidth('lg');
  return isLg ? <ChildHubPage section="reports" /> : <ChildReportsPage />;
}
